<template>
    <div 
        v-if="to && !disabled"
        class="block w-full text-left rounded-md"
    >
        <NuxtLink 
            :to="to"
            class="px-4 py-2 cursor-pointer block w-full text-left rounded-md flex items-center gap-2"
            :class="variant === 'danger' ? 'text-danger hover:bg-danger-soft' : 'text-gray-700 hover:bg-gray-200'"
        >
            <font-awesome v-if="icon" :icon="icon" class="w-4 h-4" />
            <slot></slot>
        </NuxtLink>
    </div>
    <div 
        v-else-if="disabled"
        class="px-4 py-2 block w-full text-left rounded-md text-gray-400 opacity-60 cursor-not-allowed" 
    >
        <div class="flex items-center gap-2">
            <font-awesome v-if="icon" :icon="icon" class="w-4 h-4" />
            <slot></slot>
        </div>
    </div>
    <div 
        v-else
        class="px-4 py-2 cursor-pointer block w-full text-left rounded-md" 
        :class="variant === 'danger' ? 'text-danger hover:bg-danger-soft' : 'text-gray-700 hover:bg-gray-200'"
        @click="$emit('click', $event)"
    >
        <div class="flex items-center gap-2">
            <font-awesome v-if="icon" :icon="icon" class="w-4 h-4" />
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type: Array
    },
    variant: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'danger'].includes(value)
    },
    to: {
        type: [String, Object],
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

defineEmits(['click']);
</script>